export default function QuestionItem({ question, onAnswer, userAnswer }) {
  const correctOptionsCount =
    question.options?.filter(
      (opt) => opt.is_correct === true || opt.is_correct === 1
    ).length || 0;
  const isMultipleAnswer =
    question.question_type === "multiple_choice_multiple_answer" ||
    (question.question_type === "multiple_choice" && correctOptionsCount > 1);
  const isSingleAnswer =
    question.question_type === "multiple_choice" && correctOptionsCount <= 1;

  const handleOption = (key) => {
    onAnswer({ question_id: question.id, option_id: key });
  };

  const handleText = (e) => {
    onAnswer({ question_id: question.id, answer: e.target.value });
  };

  const handleTrueFalse = (val) => {
    onAnswer({ question_id: question.id, answer: val });
  };

  return (
    <div className="mb-6 p-5 border-2 border-primary rounded-xl bg-white shadow-md">
      <p className="font-poppins font-semibold text-primary mb-3">
        {question.number}. {question.question_text}
      </p>

      {/* Multiple Choice (Single or Multiple) */}
      {(isSingleAnswer || isMultipleAnswer) && question.options && (
        <div className="grid grid-cols-1 gap-3">
          {question.options.map((opt) => {
            if (isMultipleAnswer) {
              const isSelected = userAnswer?.option_ids?.includes(opt.id);
              return (
                <label
                  key={opt.id}
                  className="flex items-center space-x-3 cursor-pointer p-3 rounded-lg border border-gray-300 hover:bg-accent hover:text-white transition"
                >
                  <input
                    type="checkbox"
                    name={`q-${question.id}`}
                    value={opt.id}
                    checked={isSelected || false}
                    onChange={() => {
                      const currentSelected = userAnswer?.option_ids || [];
                      let newSelected;
                      if (currentSelected.includes(opt.id)) {
                        newSelected = currentSelected.filter(
                          (id) => id !== opt.id,
                        );
                      } else {
                        newSelected = [...currentSelected, opt.id];
                      }
                      onAnswer({
                        question_id: question.id,
                        option_ids: newSelected,
                      });
                    }}
                    className="checkbox checkbox-primary"
                  />
                  <span className="font-poppins">{opt.option_text}</span>
                </label>
              );
            } else {
              return (
                <label
                  key={opt.id}
                  className="flex items-center space-x-3 cursor-pointer p-3 rounded-lg border border-gray-300 hover:bg-accent hover:text-white transition"
                >
                  <input
                    type="radio"
                    name={`q-${question.id}`}
                    value={opt.id}
                    checked={userAnswer?.option_id === opt.id}
                    onChange={() => handleOption(opt.id)}
                    className="radio radio-primary"
                  />
                  <span className="font-poppins">{opt.option_text}</span>
                </label>
              );
            }
          })}
        </div>
      )}

      {/* True/False */}
      {question.question_type === "true_false" && (
        <div className="flex space-x-4">
          {[true, false].map((val) => (
            <label
              key={val}
              className="flex items-center space-x-2 cursor-pointer p-3 rounded-lg border border-gray-300 hover:bg-accent hover:text-white transition"
            >
              <input
                type="radio"
                name={`q-${question.id}`}
                value={val}
                checked={userAnswer?.answer === val}
                onChange={() => handleTrueFalse(val)}
                className="radio radio-primary"
              />
              <span className="font-poppins font-semibold">
                {val ? "TRUE" : "FALSE"}
              </span>
            </label>
          ))}
        </div>
      )}

      {/* Short Answer */}
      {(question.question_type === "short_answer" ||
        question.question_type === "fill_in_the_blank") && (
        <input
          type="text"
          placeholder="Ketik jawaban (1 kata)"
          value={userAnswer?.answer || ""}
          onChange={handleText}
          className="input input-bordered input-primary w-full font-poppins"
        />
      )}
    </div>
  );
}
